var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchskill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_841_1285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66624 6.66667H6.66624V4.66667L4.33291 2.33334C5.07933 1.97685 5.91791 1.86054 6.73318 2.00042C7.54844 2.1403 8.30029 2.52948 8.8852 3.11439C9.4701 3.69929 9.85928 4.45114 9.99916 5.26641C10.139 6.08167 10.0227 6.92025 9.66624 7.66667L13.6662 11.6667C13.9315 11.9319 14.0805 12.2916 14.0805 12.6667C14.0805 13.0417 13.9315 13.4015 13.6662 13.6667C13.401 13.9319 13.0413 14.0809 12.6662 14.0809C12.2912 14.0809 11.9315 13.9319 11.6662 13.6667L7.66624 9.66667C6.91982 10.0232 6.08124 10.1395 5.26598 9.99959C4.45071 9.85971 3.69886 9.47053 3.11396 8.88562C2.52906 8.30072 2.13987 7.54887 1.99999 6.7336C1.86011 5.91834 1.97643 5.07976 2.33291 4.33334L4.66624 6.66667Z",
    stroke: "#828E99",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_841_1285"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchskill);
export default __webpack_public_path__ + "static/media/searchskill.97a6135e80d10b2f30362d7eddc0de31.svg";
export { ForwardRef as ReactComponent };